// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"FR-z","categoryName":"GR-z","categoryNameSearchHeader":"HR-z","categoryContent":"IR-z","bottomAligned":"JR-z","image":"KR-z","imageNoBackground":"LR-z"};